import React from 'react';
import { workProcess } from '../data/mockData';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import MobileSlider from './MobileSlider';

const ProcessStep = ({ step, index }) => {
  const anim = useScrollAnimation({ threshold: 0.15 });
  return (
    <div ref={anim.ref} data-testid={`process-step-${step.id}`}
      className={`group hover-soft border border-[#E2E2F0] bg-white rounded-2xl p-7 h-full scroll-fade-up scroll-delay-${index+1} ${anim.isVisible?'scroll-visible':''}`}>
      <span className="text-5xl font-semibold text-[#6366F1]/10 block mb-4 group-hover:text-[#6366F1]/25 transition-colors" style={{fontFamily:"'Playfair Display',serif"}}>{step.step}</span>
      <h3 className="text-lg font-semibold text-[#1E1B4B] tracking-tight mb-3 group-hover:text-[#6366F1] transition-colors" style={{fontFamily:"'Playfair Display',serif"}}>{step.title}</h3>
      <p className="text-sm font-normal text-[#4B5563] leading-relaxed">{step.description}</p>
    </div>
  );
};

const HowWeWorkSection = () => {
  const header = useScrollAnimation({ threshold: 0.2 });
  return (
    <section id="process" data-testid="process-section" className="py-16 md:py-32 bg-[#F5F3FF]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-10 md:mb-16 scroll-fade-up ${header.isVisible?'scroll-visible':''}`}>
          <span className="text-xs tracking-[0.2em] uppercase text-[#6366F1] mb-3 block font-semibold">Our Process</span>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#1E1B4B] mb-4" style={{fontFamily:"'Playfair Display',serif"}}>Three Steps to Federal Protection.</h2>
          <p className="text-base font-normal text-[#4B5563] leading-relaxed">A clear, efficient process — designed to move your brand from exposed to protected.</p>
        </div>
        <div className="hidden md:grid lg:grid-cols-3 gap-5">
          {workProcess.map((s,i)=><ProcessStep key={s.id} step={s} index={i} />)}
        </div>
        <div className="md:hidden">
          <MobileSlider>{workProcess.map((s,i)=><ProcessStep key={s.id} step={s} index={i} />)}</MobileSlider>
        </div>
      </div>
    </section>
  );
};
export default HowWeWorkSection;
